<template>
    <a-empty 
    :description="description"
    :image="imgSrc || require('./empty.png')">
    </a-empty>
</template>
<script>
import { Empty } from "ant-design-vue";
export default {
	name: "YwEmpty",
	extends: Empty,
    props: {
        // 图片路径
        imgSrc: {
            type: String,
            default: ''
        },
        // 描述
        description: {
            type: String,
            default: '暂无数据'
        }
    }
};
</script>